import React from "react";

const Hero = ({ data }) => {
  // Example: Color "Inspire" and "Vision"
  const highlightWords = [
    "For",
    "Landlords",
    "Manages"
  ];
  const words = data.title.split(" ");

  return (
    <div className="text-center py-24 lg:py-32 relative">
      <h1 className="text-4xl lg:text-6xl xl:text-7xl lg:tracking-[-6px] font-popinsBold text-themeColor w-[90%] lg:w-[80%] mx-auto">
        {words.map((word, index) => {
          const cleanWord = word.replace(/[^\w]/g, ""); // remove punctuation
          const isHighlight = highlightWords.includes(cleanWord);
          return (
            <span key={index} className={isHighlight ? "text-btnColor" : ""}>
              {word}{" "}
            </span>
          );
        })}
      </h1>
      <p className="font-popinsRegular text-lg text-textColor w-[90%] lg:w-[65%] mx-auto leading-6 pt-4">
        Flex Management Systems empowers landlords with the tools they need to
        manage properties, tenants, and finances—all in one streamlined,
        intuitive platform.
      </p>
      <div className="absolute left-0 bottom-10 size-56">
        <img src="/assets/hero.png" alt="" className="size-full object-fill" />
      </div>
    </div>
  );
};

export default Hero;
